import React from 'react';
import { BookOpen, Award, Clock, Video, Users, Star, CheckCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Hero = () => {
  const navigate = useNavigate();

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="pt-24 pb-16 md:pt-32 md:pb-24 bg-gradient-to-br from-blue-900 via-blue-800 to-blue-700 text-white overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="flex flex-col lg:flex-row items-center gap-12">
          {/* المحتوى النصي */}
          <div className="w-full lg:w-1/2 space-y-8">
            <div className="space-y-6">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight">
                شريكك الموثوق في
                <span className="block text-amber-400">التميز التعليمي</span>
              </h1>
              <p className="text-xl md:text-2xl opacity-90 leading-relaxed">
                دعم أكاديمي شامل للطلاب في جميع أنحاء المملكة العربية السعودية، من المرحلة الابتدائية إلى المرحلة الثانوية.
              </p>
            </div>

            {/* الأزرار */}
            <div className="flex flex-col sm:flex-row gap-4">
              <button 
                onClick={() => scrollToSection('services')}
                className="px-8 py-4 bg-teal-600 hover:bg-teal-700 rounded-xl font-bold text-lg transition-all duration-300 transform hover:scale-105 shadow-lg"
              >
                استكشف خدماتنا
              </button>
              <button 
                onClick={() => navigate('/join-us')}
                className="px-8 py-4 bg-transparent border-2 border-white hover:bg-white hover:text-blue-800 rounded-xl font-bold text-lg transition-all duration-300"
              >
                انضم إلينا
              </button>
            </div>
            
            {/* زر احجز جلستك الآن */}
            <div className="pt-6 border-t border-white/20">
              <button 
                onClick={() => navigate('/pricing')}
                className="w-full sm:w-auto px-10 py-5 bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 rounded-xl font-bold text-xl transition-all duration-300 transform hover:scale-105 shadow-xl"
              >
                احجز جلستك الآن
              </button>
            </div>
          </div>

          {/* البطاقات الجانبية */}
          <div className="w-full lg:w-1/2 relative">
            {/* عناصر الخلفية المتحركة */}
            <div className="absolute -top-6 -left-6 bg-amber-500/30 w-20 h-20 rounded-full animate-pulse"></div>
            <div className="absolute -bottom-6 -right-6 bg-teal-500/30 w-24 h-24 rounded-full animate-pulse delay-700"></div>
            
            <div className="bg-white/10 backdrop-blur-sm p-8 rounded-2xl shadow-2xl border border-white/20">
              <div className="grid gap-6">
                {/* بطاقة الدعم المنهجي */}
                <div className="flex items-start group">
                  <div className="bg-teal-600 p-3 rounded-xl ml-4 group-hover:bg-teal-500 transition-colors">
                    <BookOpen className="h-6 w-6 text-white" />
                  </div>
                  <div>
                    <h3 className="font-bold text-xl mb-2">دعم منهجي متخصص</h3>
                    <p className="text-white/80">متوافق مع النظام التعليمي السعودي</p>
                  </div>
                </div>

                {/* بطاقة المعلمين المتميزين */}
                <div className="flex items-start group">
                  <div className="bg-amber-500 p-3 rounded-xl ml-4 group-hover:bg-amber-400 transition-colors">
                    <Award className="h-6 w-6 text-white" />
                  </div>
                  <div>
                    <h3 className="font-bold text-xl mb-2">معلمون متميزون</h3>
                    <p className="text-white/80">حاصلون على جميع الشهادات الجامعية اللازمة</p>
                  </div>
                </div>

                {/* بطاقة الجلسات المرنة */}
                <div className="flex items-start group">
                  <div className="bg-blue-600 p-3 rounded-xl ml-4 group-hover:bg-blue-500 transition-colors">
                    <Clock className="h-6 w-6 text-white" />
                  </div>
                  <div>
                    <h3 className="font-bold text-xl mb-2">جلسات مرنة</h3>
                    <p className="text-white/80">مواعيد تناسب جدولك الدراسي</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;